module.exports = __webpack_public_path__ + "static/media/logoWhite.edf93e78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/core/components/navbar/logoWhite.svg
// module id = 917
// module chunks = 21